import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./LandingPage.css";

import templeBg from "../Assets/LandingPage/gopuram-silhouette.png";
import bottomBorder from "../Assets/LandingPage/kolam-border.png";
import kanchiLogo from "../Assets/logo/KanchiLogo.png";
import fliplynLogo from "../Assets/logo/logo.svg";
import GoldenButton from "../Components/GoldenButton/GoldenButton";

const KanchiLanding = () => {
  const navigate = useNavigate();
  const { token } = useParams();   // ✅ FIXED HERE

  const [tableNumber, setTableNumber] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        console.log("------------ QR DEBUG START ------------");
        console.log("Token from URL param:", token);
        console.log("Full URL:", window.location.href);

        if (!token) {
          console.log("❌ No token found in URL");
          setError("Invalid QR Code - Token Missing");
          setLoading(false);
          return;
        }

        const apiUrl = `https://fliplyn-b-c.fly.dev/cafes/table/by-qr/${token}`;
        console.log("Calling API:", apiUrl);

        const response = await fetch(apiUrl);

        console.log("Response status:", response.status);

        const data = await response.json();
        console.log("Response JSON:", data);

        if (!response.ok) {
          throw new Error(data.detail || "QR Code not valid");
        }

        if (!data.table_number) {
          throw new Error("Table number missing in response");
        }

        // ✅ Store in localStorage
        localStorage.setItem("table_number", data.table_number);
        localStorage.setItem("table_token", token);

        setTableNumber(data.table_number);
        setLoading(false);

        console.log("------------ QR DEBUG END ------------");

      } catch (err) {
        console.error("🔥 Error fetching table:", err);
        setError("Failed to load table details");
        setLoading(false);
      }
    };

    fetchTableData();
  }, [token]);

  if (loading) {
    return (
      <div className="kanchi-container">
        <div className="kanchi-content">
          <h2>Loading Table...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="kanchi-container">
        <div className="kanchi-content">
          <h2>{error}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="kanchi-container">

      <div className="powered-wrapper">
        <span className="powered-text">Powered by Fliplyn</span>
        <img src={fliplynLogo} alt="Fliplyn" className="fliplyn-logo" />
      </div>

      <div
        className="temple-overlay"
        style={{ backgroundImage: `url(${templeBg})` }}
      />

      <div className="kanchi-content">
        <h1 className="brand-title">
          <img
            src={kanchiLogo}
            alt="Kanchi Cafe"
            className="kanchi-main-logo"
          />
        </h1>

        <p className="tagline">Divine Taste. Sacred Experience.</p>
        <p className="welcome-text">Welcome to Divine Dining</p>

        <div className="table-card">
          <span className="table-label">TABLE</span>
          <span className="table-number">
            {tableNumber ? `T${tableNumber}` : "Unknown"}
          </span>
        </div>

        <GoldenButton onClick={() => navigate("/guest-entry")}>
          Begin Your Offering
        </GoldenButton>
      </div>

      <img src={bottomBorder} alt="border" className="bottom-border" />
    </div>
  );
};

export default KanchiLanding;